import { render } from "./q9.vue?vue&type=template&id=401c858c&scoped=true"
import script from "./q9.vue?vue&type=script&lang=js"
export * from "./q9.vue?vue&type=script&lang=js"

import "./q9.vue?vue&type=style&index=0&id=401c858c&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-401c858c"],['__file',"cartridges/int_guidedProductFinder/cartridge/client/default/js/components/questionTemplates/q9.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "401c858c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('401c858c', __exports__)) {
    api.reload('401c858c', __exports__)
  }
  
  module.hot.accept("./q9.vue?vue&type=template&id=401c858c&scoped=true", () => {
    api.rerender('401c858c', render)
  })

}


export default __exports__